module.exports = __webpack_public_path__ + "static/klimaatverandering-hitte-nederland-fce31488db448a80532c623f3ed65b63.jpg";